import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);
// 检测浏览器语言
function getBrowserLanguage() {
  const lang = navigator.language || navigator.userLanguage; // 获取浏览器语言
  return lang.startsWith("zh") ? "zh" : "en"; // 只有中文使用 "zh"，其他全部 "en"
}
// 默认语言（可从 localStorage 读取）
const defaultLocale = localStorage.getItem("lang") || getBrowserLanguage();

const i18n = new VueI18n({
  locale: defaultLocale, 
  fallbackLocale: "en", // 备用语言
  messages: {
  } // 语言包初始化为空，后续动态加载
});

// 已加载的语言缓存
const loadedLanguages = [];

function setI18nLanguage(lang) {
  i18n.locale = lang;
  document.querySelector("html").setAttribute("lang", lang);
  localStorage.setItem("lang", lang);
  return lang;
}

// 动态加载语言文件
function loadLanguageAsync(lang) {

  if (!loadedLanguages.includes(lang)) {
    return import(`./lang/${lang}.json`).then((messages) => {
      i18n.setLocaleMessage(lang, messages.default);
      loadedLanguages.push(lang);
      return setI18nLanguage(lang);
    });
  }else{
    if (i18n.locale === lang) {
      return Promise.resolve(lang);
    }
  }
  
  return Promise.resolve(setI18nLanguage(lang));
}

export { i18n, loadLanguageAsync };